module.exports = __webpack_public_path__ + "PeerTip-440d483f90664382f8959a4d6fc11cef.png";